import styled from "styled-components";
import { size } from "StylesConstants";

export const PropertyBadgesContainerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  margin-bottom: 16px;
  width: 100%;

  @media screen and (min-width: ${size.desktop}) {
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 0;
  }
`;

